import { conditionConstants } from "./condition.constants";

export const conditionTranslator = {
  translateOperator
};

// const translateOperator = (condition, value, expected) => {
//   switch (condition) {
//     case conditionConstants.EQUAL:
//       return value === expected;
//     case conditionConstants.NOT_EQUAL:
//       return value !== expected;
//     case conditionConstants.GREATER_THAN:
//       return value > expected;
//     case conditionConstants.LESS_THAN:
//       return value < expected;
//     case conditionConstants.LESS_THAN_OR_EQUAL_TO:
//       return value <= expected;
//     case conditionConstants.GREATER_THAN_OR_EQUAL_TO:
//       return value >= expected;
//     case conditionConstants.ALL:
//       return value <= expected;
//     case conditionConstants.ANY:
//       return value.includes(expected);
//     case conditionConstants.NOT:
//       return !value.includes(expected);

//     default:
//       break;
//   }
// };

function translateOperator (operator){
  switch (operator) {
    case conditionConstants.operators.EQUAL:
      return "==";
    case conditionConstants.operators.NOT_EQUAL:
      return "!=";
    case conditionConstants.operators.GREATER_THAN:
      return ">";
    case conditionConstants.operators.LESS_THAN:
      return "<";
    case conditionConstants.operators.LESS_THAN_OR_EQUAL_TO:
      return "<=";
    case conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO:
      return ">=";
    case conditionConstants.operators.AND:
    return "&&";
    case conditionConstants.operators.OR:
    return "||";
    // case conditionConstants.ALL:
    //   return value <= expected;
    // case conditionConstants.ANY:
    //   return value.includes(expected);
    // case conditionConstants.NOT:
    //   return !value.includes(expected);

    default:
        return ""
  }
};
